import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
var PageHeader = function (_a) {
    var pageTitle = _a.pageTitle, backTitle = _a.backTitle, backAction = _a.backAction;
    return (_jsxs("div", { className: "bg-[#5898FD] h-[32px] flex items-center justify-center px-3", children: [backTitle && _jsxs("div", { className: "text-white text-center text-[16px] font-semibold md:text-left navigation-back", onClick: backAction, children: [_jsx(ArrowBackIcon, {}), _jsx("span", { className: "ml-3", children: backTitle })] }), _jsx("h2", { className: "text-white text-center text-[16px] font-semibold md:text-left ", children: pageTitle })] }));
};
export default PageHeader;
